module.exports = __webpack_public_path__ + "static/media/client-logo-20.2eee1f6d.jpg";